import { ScreenShot } from '@/types/ScreenShotType';
import { AxiosRequestConfig } from 'axios';
import http from './api-client';

const apiEndpoint = '/games';

/**
 * Fetches the list of game trailers from the API.
 * @param config - Configuration for the HTTP request
 * @returns Promise containing the game trailers list
 */
export const getScreenShots = async (id: number | string, config?: AxiosRequestConfig) =>
    await http
        .get<ScreenShot[]>(`${apiEndpoint}/${id}/screenshots`, { ...config })
        .then((res) => res.data);
